import script from "./QuizOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizOptions.vue?vue&type=script&setup=true&lang=js"

import "./QuizOptions.vue?vue&type=style&index=0&id=cac5ff62&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cac5ff62"]])

export default __exports__